import httpClient from '@/plugins/httpClient';

export default {
  getActivities(page) {
    return httpClient.get(`compete/activities?page=${page}&per_page=4`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/schoolApis/compete/activitiesApis.js